<div class="row">
  <div class="col-md-12">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-content class="mat-mdc-card-content text-center">
        <div class="row">
          <table class="table w-100 m-b-20">
            <thead>
            <tr>
              <th rowspan="2" class="text-center">{{ 'ItemName'|translate }}</th>
              <th [colSpan]="list.colors?.length" class="text-center">{{ 'Colors'|translate }}</th>
              <th rowspan="2" class="text-center">{{ 'ItemName'|translate }}</th>
              <th [colSpan]="list.colors?.length" class="text-center">{{ 'Colors'|translate }}</th>
            </tr>
            <tr>
              <ng-container *ngFor="let column of colorColumns">
                <th *ngFor="let color of list.colors" class="text-center">{{ color.colorName }}</th>
              </ng-container>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let itemForm of itemsWithColors; let i = index">
              <ng-container *ngFor="let column of colorColumns">
                <td>
                  <span *ngIf="itemForm[column]?.controls as control">{{ control['productName'].value }} </span>
                </td>
                <td *ngFor="let color of list.colors" class="text-center">
                  <ng-container *ngIf="GetColorItems(itemForm[column], color.id) as item">
                    <div [formGroup]="item">
                      <mat-form-field appearance="outline" class="CountInput">
                        <mat-label>{{ 'Count' | translate }}
                        </mat-label>
                        <input matInput class="txt" type="number" onwheel="return false;"
                               placeholder="{{ 'Count' | translate }} " formControlName="count"
                               maxlength="3" minlength="1" min="1" />
                        @if (item.controls['count'].touched &&
                        item.controls['count'].invalid) {
                          <mat-hint class="m-b-16 error-msg">
                            @if (item.controls['count'].errors &&
                            item.controls['count'].errors!['required']) {
                              <div class="text-error">
                                {{ 'EnterCount' | translate }}
                              </div>
                            }
                          </mat-hint>
                        }
                      </mat-form-field>
                    </div>
                  </ng-container>
                </td>

              </ng-container>
            </tr>
            </tbody>
          </table>

          <table class="table w-100 m-b-20">
            <thead>
            <tr>
              <ng-container *ngFor="let column of nonColorColumns">
                <th class="text-center">{{ 'ItemName'|translate }}</th>
                <th class="text-center">{{ 'Count'|translate }}</th>
              </ng-container>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let itemForm of itemsWithoutColors; let i = index">
              <ng-container *ngFor="let column of nonColorColumns">
                <td>
                  <span *ngIf="itemForm[column]?.controls as control">{{ control['productName'].value }} </span>
                </td>
                <td class="text-center">
                  <ng-container *ngIf="GetNonColorItems(itemForm[column]) as item">
                    <div [formGroup]="item">
                      <mat-form-field appearance="outline" class="CountInput">
                        <mat-label>{{ 'Count' | translate }}
                        </mat-label>
                        <input matInput class="txt" type="number" onwheel="return false;"
                               placeholder="{{ 'Count' | translate }} " formControlName="count"
                               maxlength="3" minlength="1" min="1"/>
                        @if (item.controls['count'].touched &&
                        item.controls['count'].invalid) {
                          <mat-hint class="m-b-16 error-msg">
                            @if (item.controls['count'].errors &&
                            item.controls['count'].errors!['required']) {
                              <div class="text-error">
                                {{ 'EnterCount' | translate }}
                              </div>
                            }
                          </mat-hint>
                        }
                      </mat-form-field>
                    </div>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
